import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=7e2fbf26&scoped=true&"
import script from "./branches.vue?vue&type=script&lang=ts&"
export * from "./branches.vue?vue&type=script&lang=ts&"
import style0 from "./branches.vue?vue&type=style&index=0&lang=css&"
import style1 from "./branches.vue?vue&type=style&index=1&id=7e2fbf26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2fbf26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VList,VListItem,VListItemContent,VListItemTitle,VNavigationDrawer,VTextField})
